define( function() {
	"use strict";

	return ( /^$|^module$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rscriptType.js
// module id = 283
// module chunks = 27